var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "header",
    {
      staticClass: "header-container",
      class: {
        rtl: _vm.dir === "rtl"
      },
      attrs: { id: _vm.header.id }
    },
    [
      _vm.desktopOrTablet
        ? _c("div", { staticClass: "utility-bar-area" }, [
            _c(
              "div",
              {
                staticClass: "header-max-width utility-bar-body",
                class: [_vm.utilityBarCenterClass]
              },
              [
                _c(
                  "div",
                  { staticClass: "utility-bar-item top-left" },
                  [
                    _c("NsMinimalHeaderRegionSelector", {
                      staticClass: "ns-minimal-region-selector",
                      attrs: {
                        "href-override": _vm.header.homeUrl,
                        region: _vm.header.region,
                        "region-selector-path": _vm.header.regionSelectorPath,
                        translations: _vm.header.translations
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "utility-bar-item top-right" })
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "header-body" },
        [
          _c("div", { staticClass: "header-layout header-max-width" }, [
            _c("div", { staticClass: "header-left" }, [
              _c(
                "div",
                { staticClass: "header-left-two" },
                [
                  _vm.header.showDistributorImage
                    ? _c(
                        "div",
                        { staticClass: "storefront-header-logo" },
                        [
                          !_vm.header.distributorImage
                            ? _c("NsMinimalHeaderLogo", {
                                attrs: {
                                  "link-url": _vm.header.homeUrl,
                                  "no-simple-logo": "",
                                  small: "",
                                  mystore: false
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c(
                            "a",
                            {
                              attrs: {
                                id: "homeLink",
                                href: _vm.header.homeUrl
                              }
                            },
                            [
                              _vm.header.distributorImage
                                ? _c("img", {
                                    staticClass: "mec-avatar is-square",
                                    attrs: {
                                      id: "headerLogoImage",
                                      src: _vm.header.distributorImage,
                                      alt: "Profile Logo"
                                    }
                                  })
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.header.showDistributorImage
                    ? _c("NsMinimalHeaderLogo", {
                        attrs: {
                          "link-url": _vm.header.homeUrl,
                          "no-simple-logo": "",
                          small: ""
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "header-right" }, [
              _c(
                "div",
                { staticClass: "header-right-one" },
                [
                  _c("NsMinimalHeaderProfileToggle", {
                    attrs: {
                      greeting: _vm.profileToggleTranslations.greeting,
                      "sign-in-label":
                        _vm.profileToggleTranslations.signInLabel,
                      "sign-up-label":
                        _vm.profileToggleTranslations.signUpLabel,
                      "sign-out-label":
                        _vm.profileToggleTranslations.signOutLabel,
                      "sign-up-href": _vm.header.signUpUrl,
                      "sign-out-url": _vm.header.signOutUrl,
                      "profile-url": _vm.header.profileUrl
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "header-right-two" },
                [
                  _c("NsMinimalHeaderMiniCart", {
                    staticClass: "ns-mini-cart",
                    attrs: {
                      "shopping-bag-text": _vm.header.cartText,
                      "show-shopping-bag-text": _vm.header.showCartText
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "header-right-three" }, [
                _c(
                  "div",
                  { staticClass: "menu-button", on: { click: _vm.toggleMenu } },
                  [_c("NsIcon", { attrs: { "icon-name": "icon-hamburger" } })],
                  1
                )
              ])
            ])
          ]),
          _vm._v(" "),
          _c("NsMinimalHeaderTopnav", {
            staticClass: "header-max-width header-divider max-width-only"
          })
        ],
        1
      ),
      _vm._v(" "),
      !_vm.desktop
        ? _c(
            "NsMinimalDrawer",
            {
              attrs: { open: _vm.mobileDrawerOpen, width: "300" },
              on: {
                close: function($event) {
                  _vm.mobileDrawerOpen = false
                }
              }
            },
            [
              _c("NsMinimalHeaderDrawer", {
                attrs: {
                  region: _vm.header.region,
                  "href-override": _vm.header.homeUrl,
                  "region-selector-path": _vm.header.regionSelectorPath,
                  "signup-href": _vm.header.signUpUrl,
                  translations: _vm.headerDrawerTranslations,
                  "join-us": _vm.header.joinUs,
                  "legal-links": _vm.header.legalLinks
                },
                on: {
                  "close-drawer": function($event) {
                    _vm.mobileDrawerOpen = false
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "header",
                      fn: function() {
                        return [
                          !_vm.desktop
                            ? _c("NsMinimalHeaderProfileDropdownMobile", {
                                attrs: {
                                  "profile-menu": _vm.header.profileMenu,
                                  "sign-out-url": _vm.header.signOutUrl,
                                  "sign-up-url": _vm.header.signUpUrl,
                                  "profile-url": _vm.header.profileUrl,
                                  translations: _vm.header.translations,
                                  "profile-translations":
                                    _vm.profileToggleTranslations
                                },
                                on: {
                                  "close-drawer": function($event) {
                                    _vm.mobileDrawerOpen = false
                                  }
                                }
                              })
                            : _vm._e()
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1940339223
                )
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }